import type {
  StoreFunnelSettingsInterface,
  StoreFunnelStep,
} from '@innogy/feh/models';
import type { StoreProductData } from '@legacy/common-ui-models';
import { createAction, props } from '@ngrx/store';
import { createNamedFunnelActions } from '@innogy/feh/shared';

const feature = 'Store';

export const {
  initializeStoreFunnelStepAction,
  clearStoreFunnelInitializedAction,
  setStoreFunnelInitializedAction,
  onStoreFunnelNavigationAction,
  handleStoreFunnelPrivateErrorAction,
  handleStoreFunnelGenericErrorAction,
  selectStoreProductAction,
  selectStoreProductsAction,
  toggleStoreProductSelectionAction,
  resetStoreProductSelectionAction,
  confirmStoreProductSelectionAction,
  mintStoreTrackingIdAction,
} = createNamedFunnelActions<
  typeof feature,
  StoreFunnelStep,
  StoreFunnelSettingsInterface,
  StoreProductData
>(feature);

export const storeAssociatedGenericFormIdAction = createAction(
  `[${feature} Funnel] store associated generic form id`,
  props<{ formId: string; instanceId: string }>()
);
